import { type ChartSeries } from "@mantine/charts";
import { seriesColors } from "../../../mantine/charts/mantine.constants";

export function getColoredSeries<T extends ChartSeries>(
  series: ReadonlyArray<T>
) {
  return series.map<T & { color: string }>((singleSeries, index) => ({
    ...singleSeries,
    color: singleSeries.color || seriesColors[index % seriesColors.length]
  }));
}
